import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Image, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaHandsHelping, FaDonate, FaUserFriends, FaUniversity, FaQrcode, FaInfoCircle } from 'react-icons/fa';
import './Donate.css';

const Donate = () => {
  const mainColor = '#006186';
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Здесь логика отправки данных
  };

  return (
    <div className="donate-page bg-white">
      <Container className="py-5">
        {/* КАРТОЧКИ ИНФОРМАЦИИ */}
        <Row className="g-4 mb-5">
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm rounded-4 p-4">
              <h5 className="fw-bold mb-3 d-flex align-items-center" style={{ color: mainColor }}>
                <FaDonate className="me-2" /> Финансовая помощь
              </h5>
              <p className="text-muted small">Поддержите университет прямым переводом. Все средства направляются на уставную деятельность и стипендии.</p>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm rounded-4 p-4">
              <h5 className="fw-bold mb-3 d-flex align-items-center" style={{ color: mainColor }}>
                <FaUserFriends className="me-2" /> Интеллектуальный вклад
              </h5>
              <p className="text-muted small">Вы можете передать оборудование, провести мастер-класс или стать ментором для наших студентов.</p>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center mb-5">
          <Col lg={6} md={8}>
            <div className="credit-card-container">
              <motion.div
                initial={{ rotateY: -10, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="bank-card shadow-lg"
              >
                <div className="card-glass-overlay"></div>

                {/* Верхняя часть карты */}
                <div className="card-top d-flex justify-content-between align-items-start">
                  <div className="bank-info">
                    <div className="card-type-label">University Support Card</div>
                  </div>
                  <img src="/logo_oshtu.png" alt="OSHTU" className="card-uni-logo" />
                </div>

                {/* Чип */}
                <div className="card-chip">
                  <div className="chip-line"></div>
                  <div className="chip-line"></div>
                  <div className="chip-line"></div>
                </div>

                {/* Номер счета */}
                <div className="card-number-box">
                  <div className="card-label">CARD NUMBER</div>
                  <div className="card-number">1111 1111 1111 111</div>
                </div>

                {/* Нижняя часть карты */}
                <div className="card-bottom d-flex justify-content-between align-items-end">
                  <div className="card-holder">
                    <div className="holder-name text-uppercase">Osh Technological University</div>
                  </div>
                  <div className="card-currency">KGS</div>
                </div>
              </motion.div>

              <div className="text-center mt-4">
                <p className="text-muted small">
                  <FaInfoCircle className="me-1" />
                  Используйте эти реквизиты для перевода через мобильный банкинг любого банка
                </p>
              </div>
            </div>
          </Col>
        </Row>

        {/* ФОРМА */}
        <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
          <div className="p-4 text-white fw-bold" style={{ backgroundColor: mainColor }}>
            УВЕДОМИТЬ О ПОДДЕРЖКЕ
          </div>
          <Card.Body className="p-4 p-lg-5 bg-light-subtle">
            {submitted ? (
              <Alert variant="success" className="text-center py-4 border-0 shadow-sm">
                <h4 className="fw-bold">Спасибо за поддержку!</h4>
                <p className="mb-0">Ваше сообщение отправлено в отдел по связям с выпускниками.</p>
              </Alert>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold">ФИО *</Form.Label>
                      <Form.Control type="text" required className="border-0 shadow-sm py-2" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold">Email *</Form.Label>
                      <Form.Control type="email" required className="border-0 shadow-sm py-2" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold">Телефон *</Form.Label>
                      <Form.Control type="text" required className="border-0 shadow-sm py-2" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label className="small fw-bold">Сумма (KGS)</Form.Label>
                      <Form.Select className="border-0 shadow-sm py-2">
                        <option>1000</option>
                        <option>5000</option>
                        <option>Другая сумма</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Check type="checkbox" label="Анонимное пожертвование" className="small text-muted mb-4" />
                    <Button
                      type="submit"
                      className="w-100 py-3 border-0 fw-bold"
                      style={{ backgroundColor: mainColor }}
                    >
                      ОТПРАВИТЬ ДАННЫЕ
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Donate;